import {
  SignalOriginSchema,
  type SignalOriginType,
} from '@terra/shared-schemas-orchestrator';

export const USER_CREATED_SIGNAL_ORIGINS = [
  SignalOriginSchema.enum.MANUAL,
  SignalOriginSchema.enum.CO_PILOT,
] as const satisfies readonly SignalOriginType[];

const USER_CREATED_SIGNAL_ORIGIN_SET = new Set<SignalOriginType>(
  USER_CREATED_SIGNAL_ORIGINS,
);

export const isUserCreatedSignalOrigin = (origin: SignalOriginType): boolean =>
  USER_CREATED_SIGNAL_ORIGIN_SET.has(origin);

export const isCopilotToolEndpointEditableSignalOrigin = (
  origin: string,
): boolean => origin === SignalOriginSchema.enum.CO_PILOT;

export const hasCopilotToolEndpointUpdateFields = ({
  endpointId,
  harEntryId,
  entryPointId,
}: {
  endpointId?: string;
  harEntryId?: string;
  entryPointId?: string;
}): boolean =>
  endpointId !== undefined ||
  harEntryId !== undefined ||
  entryPointId !== undefined;

export const omitCopilotToolEndpointUpdateFields = <
  T extends {
    endpointId?: string;
    harEntryId?: string;
    entryPointId?: string;
  },
>({
  endpointId: _endpointId,
  harEntryId: _harEntryId,
  entryPointId: _entryPointId,
  ...rest
}: T): Omit<T, 'endpointId' | 'harEntryId' | 'entryPointId'> => rest;

export const SIGNAL_CONTENT_UPDATE_FIELDS = [
  'description',
  'analysis',
  'confidence',
  'reason',
] as const;

export type SignalContentUpdateField =
  (typeof SIGNAL_CONTENT_UPDATE_FIELDS)[number];

export const hasSignalContentUpdates = ({
  updates,
}: {
  updates: Record<string, unknown>;
}): boolean =>
  SIGNAL_CONTENT_UPDATE_FIELDS.some((field) => updates[field] !== undefined);
